<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="currencymodal"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="(submitted==true?loaderIcon:'')+(page=='create'?'Add':'Update')"
      :title="(page=='create'?'Add':'Update') +' Currency'"
      ref="currencymodal"
      @ok.prevent="onSubmit"
      scrollable
      :ok-disabled="submitted"
    >
      <div class="container-fluid">
        <b-alert
          class="alert-transparent alert-danger"
          :show="(error_show && errors.any())||error_msg"
        >
          <button type="button" @click="error_show=!error_show;error_msg=!error_msg;" class="close">
            <span aria-hidden="true">&times;</span>
          </button>
          <p v-for="item in errors.items" :key="item.id" class="fw-semi-bold">{{ item.msg }}</p>
          <p class="fw-semi-bold" v-if="error_msg">{{ message }}</p>
        </b-alert>
      </div>
      <b-form>
        <b-row class="mx-0">
          <b-col>
            <b-form-group label="Currency Code" label-for="label-name" label-class="required">
              <v-select
                :clearable="false"
                id="search-select"
                name="currency"
                data-vv-name="currency"
                v-validate="'required'"
                size="sm"
                @change="changeCurrency"
                v-model="currency_detail.code"
                :label="page=='create'?'currency_name':'currency_code'"
                index="currency_code"
                :options="$AppDetails.currency_list"
                :disabled="page=='update'"
              />
            </b-form-group>
            <b-form-group label="Currency Symbol" label-for="label-name" label-class="required">
              <b-input
                name="currency symbol"
                data-vv-name="currency symbol"
                v-model="currency_detail.symbol"
                v-validate="'required|max:4'"
              ></b-input>
            </b-form-group>
            <b-form-group label="Currency Name" label-for="label-name" label-class="required">
              <b-input
                name="currency name"
                data-vv-name="currency name"
                v-validate="'required|max:100'"
                v-model="currency_detail.name"
              ></b-input>
            </b-form-group>
            <b-form-group label="Decimal Places" label-for="label-name">
              <b-select v-model="currency_detail.decimal_places" disabled>
                <option :value="1">0</option>
                <option :value="2">2</option>
                <option :value="3">3</option>
              </b-select>
            </b-form-group>
            <b-form-group label="Format" label-for="label-name">
              <b-select v-model="currency_detail.format" disabled>
                <option :value="1">1,234.56</option>
                <option :value="2">1 234,56</option>
                <option :value="3">1.234,56</option>
              </b-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer v-if="page=='update'&&exchange_status==1">
        <div class="w-100">
          <b-button
            v-if="base_currency!=currency_detail.id"
            variant="primary"
            size="sm"
            class="float-right"
            v-b-modal.exchange_rate_modal
            @click="exchange_rate=createFreshData();$refs.currencymodal.hide()"
          >Add Exchange Rate</b-button>
        </div>
      </template>
    </b-modal>
    <ExchangeRate
      @success="recallData()"
      :currency_code="currency_detail.code"
      :exchange_rate="exchange_rate"
    ></ExchangeRate>
  </div>
</template>
<script>
import store from "@/store/index"; // vuex store fucntion
import vSelect from "vue-select";
import { mapState } from "vuex";
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import ExchangeRate from "@/components/Modal/Currency/ExchangeRate"; // to excel export the output

export default {
  components: { vSelect, ExchangeRate },
  mixins: [notificationMixin], //call the global mixin function
  props: ["currency_detail", "page"],
  data() {
    return {
      error_show: false,
      error_msg: false,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      exchange_rate: this.createFreshData()
    };
  },
  methods: {
    createFreshData() {
      return {
        currency_id: this.currency_detail.id,
        date: "",
        value: "",
        code: this.currency_detail.code
      };
    },
    //function for update field for currency field change
    changeCurrency(event) {
      if (this.page == "create") {
        var temp = this;
        this.$AppDetails.currency_list.map(function(value) {
          if (value.currency_code == event) {
            temp.currency_detail.symbol = value.currency_symbol;
            temp.currency_detail.name = value.currency;
            temp.currency_detail.id = value.currency_id;
          }
        });
      }
    },
    // create or update function for the currency data
    async onSubmit() {
      this.orgCurrencySymbol = this.getDetails(
        this.$AppDetails.currency_details,
        this.$AppDetails.organization.org_currency,
        "currency_symbol"
      );
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          this.error_show = false;

          var data = JSON.stringify(this.currency_detail);
          var url = this.page == "create" ? "createCurrency" : "updateCurrency";
          if (this.page == "update") {
            if (this.base_currency == this.currency_detail.id) {
              this.orgCurrencySymbol = this.currency_detail.symbol;
            }
            data = {
              id: this.currency_detail.id,
              data: JSON.stringify(this.currency_detail)
            };
          }
          this.$store.dispatch("currency/" + url, data).then(() => {
            this.submitted = false;
            if (this.type == "success") {
              this.error_msg = false;
              //to show the alert message for success or error after api call
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.message,
                type: this.type,
                showCloseButton: true
              });
             store.dispatch("currency/fetchLists").then(()=>{
                if(this.page=='update'){
                var data = JSON.stringify({
                id:this.currency_detail.org_id,
                app_id: process.env.VUE_APP_APP_ID
      });
               this.$store.dispatch("session/switchSession", data);
                }
              this.$refs.currencymodal.hide();
              this.$emit("addedCurrency", this.currency_detail.id)
                 });
            } else {
              this.error_msg = true;
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    recallData() {
      store.dispatch("currency/fetchLists");
    }
  },
  computed: {
    orgCurrencySymbol: {
      get() {
        return this.$store.state.permission.orgCurrencySymbol;
      },
      set(value) {
        this.$store.state.permission.orgCurrencySymbol = value;
      }
    },
    ...mapState({
      lists: state => state.currency.lists,
      message: state => state.currency.message,
      type: state => state.currency.type,
      exchange_status: state => state.currency.exchange_status,
      base_currency: state => state.currency.base_currency
    })
  }
};
</script>